import { v4 as uuid } from 'uuid';
import _ from 'lodash';
import { userToString } from './auth.utils';
import { dateToDateString } from './date.utils';

export const getSubmittedByFromUser = (user) => {
  return _.pick(user, ['contactId', 'firstName', 'lastName', 'userName', 'email']);
};

export const setFormValuesRecursive = (fields, mapping, user, result, hasSteps) => {
  try {
    if (hasSteps) {
      for (const step of fields) {
        const inMapping = _.filter(_.get(step, 'fields', []), (el) => Object.keys(mapping).includes(el.name));
        if (inMapping.length > 0) {
          for (const item of inMapping) {
            result[item.name] = user[mapping[item.name]];
          }
        }
      }
    } else {
      for (const field of fields) {
        if (!Array.isArray(_.get(field, 'spec.options.fields', {})) || !_.get(field, 'spec.options.fields', null)) {
          if (Object.keys(mapping).includes(field.name)) {
            result[field.name] = user[mapping[field.name]];
          }
        } else {
          const inMapping = _.filter(_.get(field, 'spec.options.fields', []), (el) =>
            Object.keys(mapping).includes(el.name)
          );
          if (inMapping.length > 0) {
            result[field.name] = {};
            for (const item of inMapping) {
              result[field.name][item.name] = user[mapping[item.name]];
            }
          }
          setFormValuesRecursive(_.get(field, 'spec.options.fields', []), mapping, user, result);
        }
      }
    }
  } catch (error) {
    console.warn(`setFormValuesRecursive - could not set values, ${error.message}`);
  }
};

export const getIntro = (form) => form?.template?.content?.body ?? '';

const FORMS_ENGINE_BOOLEAN_FIELD_TYPES = ['checkbox'];
const FORMS_ENGINE_SIMPLE_VALUE_FIELD_TYPES = [
  'text',
  'textarea',
  'number',
  'national-number',
  'time',
  'mask',
  'email',
  'phone',
  'iban'
];
const FORMS_ENGINE_SINGLE_SELECT_FIELD_TYPES = ['select', 'autocomplete', 'radio'];
const FORMS_ENGINE_MULTI_SELECT_FIELD_TYPES = ['multicheckbox'];
const FORMS_ENGINE_DATE_FIELD_TYPES = ['date'];
export const FORMS_ENGINE_RICH_TEXT_FIELD_TYPES = ['wysiwyg'];
const FORMS_ENGINE_ADDRESS_FIELD_TYPES = ['location-picker'];

const _answerToString = (field, fieldValue) => {
  const fieldType = field?.spec?.control?.name;
  let valueString = '';
  if ([...FORMS_ENGINE_SIMPLE_VALUE_FIELD_TYPES, ...FORMS_ENGINE_RICH_TEXT_FIELD_TYPES].includes(fieldType)) {
    valueString = fieldValue ?? '';
  }
  if (FORMS_ENGINE_BOOLEAN_FIELD_TYPES.includes(fieldType)) {
    valueString = !!fieldValue ? 'Ja' : 'Nee';
  }
  if (FORMS_ENGINE_SINGLE_SELECT_FIELD_TYPES.includes(fieldType)) {
    valueString = fieldValue?.value ?? '';
  }
  if (FORMS_ENGINE_MULTI_SELECT_FIELD_TYPES.includes(fieldType)) {
    valueString = fieldValue
      ?.map((v) => v?.value ?? '')
      ?.filter((x) => !!x)
      ?.join(', ');
  }
  if (FORMS_ENGINE_DATE_FIELD_TYPES.includes(fieldType)) {
    valueString = dateToDateString(fieldValue) || fieldValue || '';
  }
  if (FORMS_ENGINE_ADDRESS_FIELD_TYPES.includes(fieldType)) {
    valueString = fieldValue?.formattedAddress ?? '';
  }
  return valueString;
};

export const getAnswersByField = (answers, form) => {
  console.log(form?.template?.content?.fields);
  console.log(answers);
  if (!form?.template?.content?.fields) {
    return (
      Object.keys(answers?.[0]?.form)?.map((fieldName) => ({
        uuid: uuid(),
        fieldName,
        label: answers?.[0]?.form?.[fieldName]?.label ?? fieldName,
        answers: answers?.map((a) => ({
          user: userToString(a?.submittedBy),
          answer: _answerToString(
            { spec: { control: { name: answers?.[0]?.form?.[fieldName]?.type } } },
            answers?.[0]?.form?.[fieldName]?.value
          ),
          answerType: answers?.[0]?.form?.[fieldName]?.type
        }))
      })) ?? []
    );
  }
  return (
    form?.template?.content?.fields?.map((f) => ({
      uuid: uuid(),
      fieldName: f.name,
      label: f?.spec?.options?.label,
      answers: answers?.map((a) => ({
        user: userToString(a?.submittedBy),
        answer: _answerToString(f, a?.form?.[f.name]?.value),
        answerType: f?.spec?.control?.name
      }))
    })) ?? []
  );
};

export const formSnapshotToData = (snapshot = {}) => {
  const result = {};

  Object.keys(snapshot).forEach((key) => {
    result[key] = snapshot[key].value;
  });

  return result;
};
